export default class IndisponibilidadeMotivoEnum {
    static Ferias = 1
    static Folga = 2
    static Falta = 3
    static Outro = 4
}
